
import { UrlPath } from '../../../config/routeConfig';
import {
    SBADropDown,
    SBAMultiSelect,
    SBAComboBox,
    SBAMultiSelectCheck,
    SBAMultiColumnComboBox,
} from "../../UiComponents/SBADropDown";
import { GetAllGlobalEntities } from "../../actions/globalSearchAction";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import Searchicon from '../../asset/Images/search.svg';
import { Link } from "react-router-dom";
import { callMsGraph, loginRequest } from '../../../authConfig';
import { useNavigate } from "react-router";
import { useMsal } from "@azure/msal-react";
import { setActiveMenu } from '../../actions/CommonAction';
import { Dropdown, Badge } from 'react-bootstrap';
import { useNotification } from '../../../ContentRoutes';
import { checkNotificationAccess } from '../../../config/apiConfig';
import { sbaAxios } from '../../utils/sbaAxios';

export const ProfileContainer=()=>{
    const { instance, accounts } = useMsal();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogOut = () => {

        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
        sessionStorage.clear();
        localStorage.clear();
        //localStorage.removeItem('entryKey');
        //localStorage.removeItem('idToken');
        //dispatch(logout());
    };
    return(
    <>
      <Dropdown>
      <Dropdown.Toggle as="button" className="btn border rounded mx-1">
      <button className="btn border-0" type="button" id="UserProfile" data-bs-toggle="dropdown"
aria-expanded="false"><i className="fa-regular fa-user"></i></button>
      </Dropdown.Toggle>

      <Dropdown.Menu align="end">
        <Dropdown.Item onClick={()=>{navigate('/Settings')}}>
          <i className="fa-solid fa-gear me-1"></i> User Preferences
        </Dropdown.Item>
        <Dropdown.Item onClick={handleLogOut}>
          <i className="fa-solid fa-power-off me-1"></i> Sign Out
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
    </>
    )
};


//  <div className="dropdown profile border px-3 py-1 rounded mx-3">
{/* <button className="btn border-0" type="button" id="UserProfile" data-bs-toggle="dropdown"
aria-expanded="false"><i className="fa-regular fa-user"></i></button>
<ul className="dropdown-menu dropdown-menu-end p-0" aria-labelledby="UserProfile">
{/* <li><Link to={`${UrlPath.Profile}`} className="dropdown-item small p-3" ><i
          className="fa-solid fa-address-card me-1"></i>  My
        Profile</Link> </li> */}
{/* <li><label className="dropdown-item small p-3" href="#"><i className="fa-solid fa-user-pen me-1"></i>
        Edit
        Profile</label></li>
<li><label className="dropdown-item small p-3" href="#"><i className="fa-solid fa-key me-1"></i> Change
        Password</label></li> */}
{/*<li className='SBA_hand'><a className="dropdown-item small p-3" onClick={()=>handleLogOut()}><i
            className="fa-solid fa-power-off me-1"></i> Sign Out</a></li>
</ul>
</div> */}
export const NotificationContainer=()=>{


    const {notifications, setShowNotificationDrawer}=useNotification();
    const [hasAccess, setHasAccess] = useState(false);
    const checkAccess = async() => {
      try{
        const res = await sbaAxios({url:checkNotificationAccess});
        setHasAccess(res);
      }
      catch(e){
        setHasAccess(false);
      }
    }
    useEffect(()=>{
      checkAccess();
    },[]);
    return(
      <>
      {hasAccess?<div >
     <Dropdown align="end" >
    <Dropdown.Toggle
      variant="light"
      id="notifications"
      className="position-relative border-0 bg-transparent shadow-none"
    >
      <img   src={"/images/Notification_icon_black.svg"}/>
      {notifications.length > 0 && (
        <Badge
          bg="danger"
          text="light"
          pill
          className="position-absolute top-0 start-90 translate-middle rounded-circle"
        >
          {notifications.length}
          <span className="visually-hidden">unread messages</span>
        </Badge>
      )}
    </Dropdown.Toggle>
    <Dropdown.Menu className="notifications p-0">
      <div className="notification-title d-flex align-items-center border-bottom p-3 SBA_hand" onClick={()=>{setShowNotificationDrawer(val=>true)}} >
        <h6 className="h6 mb-0 me-auto">Notifications</h6>
      </div>
    </Dropdown.Menu>
  </Dropdown>
    
    </div>:null}
      </>
    )
   

}
export const SearchContainner = () => {
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state) || {};
    const GlobalEntities = useSelector((state) => state.AllEntities.AllEntities) || [];
    const [selectedEntity, setSelectedEntity] = useState();
    const [selectedEntityName, setSelectedEntityName] = useState();
    const [selectedEntityType, setSelectedEntityType] = useState();
    const history = useNavigate();
    const NamesOnChange = (e) => {
        const SearchTerm = e.filter.value;
        const isContains = false;
        if (SearchTerm.length > 2)
            dispatch(GetAllGlobalEntities(SearchTerm, isContains));
    }
    const EntitesChanged = (e) => {
        setSelectedEntity(e.value.EntityId);
        setSelectedEntityType(e.value);
        setSelectedEntityName(e.value.EntityName);       
        if ((e.value.EntityTypeName) == "Asset") {
            history(`${UrlPath.AssetDetails}${e.value.EntityId}`);
            dispatch(setActiveMenu(2));
        }
        if ((e.value.EntityTypeName) == "Portfolio") {
            history(`${UrlPath.AssetDetails}${e.value.EntityId}`);
            dispatch(setActiveMenu(3));
        }
        if ((e.value.EntityTypeName) == "Universe") {
            history(`${UrlPath.UniverseMembers}${e.value.EntityId}`);
            dispatch(setActiveMenu(6));
        }
        if ((e.value.EntityTypeName) == "Index") {           
            history(`${UrlPath.MarketDataDetails}${e.value.EntityId}`);
            dispatch(setActiveMenu(40));
        }
    }  
    const columns = [
        {
            field: "EntityName",
            header: "Name",
            width: '300px',             
    },
        { field: "EntityTypeName", header: "Type", width: '100px' }
    ];

    return (
      <div>           
                <div className="position-relative" style={{width:"30rem"}}>
                    <SBAMultiColumnComboBox
                        className="w-150 search-cb"
                        data={GlobalEntities}
                        value={selectedEntityName}
                        columns={columns}
                        filterable={true}
                        textField="EntityName"
                        valueField="EntityId"
                        onFilterChange={NamesOnChange}
                        onChange={EntitesChanged}
                        placeholder = {'Global Search'}
                    />
                    {/* <img className="nav-search position-absolute translate-middle" src={Searchicon} alt="" /> */}
                
            </div>
        </div>           
    )
}
export const HelpContainer=()=>{
    const OpenHelpWindow=()=>{
        const pathSegments = window.location.pathname.split("/");
        const model = pathSegments[1];
        const url = `${UrlPath.Help}?section=${model}`;
        window.open(url,'_blank');
    }
    return <>
   <div className="dropdown profile border px-1 py-1 rounded mx-1" 
      onClick={()=>{  OpenHelpWindow()  }}
   >

                  <button className="btn border-0" type="button" id="question" 
                      aria-expanded="false"><i class="fa-solid fa-question"
                    //   onClick={()=>{  OpenHelpWindow()  }}
                      ></i></button>
                 
              </div>
    </>
}